import { useEffect } from 'react';
import {
  useAdditionalBundleStockLevels,
  useBundledProducts,
  useSaveAdditionalBundleStockLevel,
  useSetAdditionalBundleStockLevel
} from '../useCustomerCatalogueService';
import { StockBinLevel, useDefaultBundleStockLevels } from './useDefaultBundleStockLevels';

export const useSaveInitialDefaultBundleStocks = () => {
  const bundledProducts = useBundledProducts();
  const additionalStockLevels = useAdditionalBundleStockLevels();
  const defaultLevels = useDefaultBundleStockLevels();

  const set = useSetAdditionalBundleStockLevel();
  const save = useSaveAdditionalBundleStockLevel();

  useEffect(() => {
    const itemsToSave: StockBinLevel[] = [];

    bundledProducts.forEach(product => {
      const additionalStock = additionalStockLevels.find(a => a.productId === product.id);
      const defaultLevel = defaultLevels.find(d => d.product.id === product.id);

      if (!additionalStock) {
        itemsToSave.push({
          product,
          maxStockLevel: defaultLevel?.maxStockLevel || 0,
          minStockLevel: defaultLevel?.minStockLevel || 0
        });
      }
    });

    // Need to save initial state in case additional stocks are never save manually (i.e. fine with the default values)
    // Ideally would only be a one time thing (i.e. when additional stocks length is 0) but new bundled items can be added at any point.
    const saveInitialStocks = async () => {
      itemsToSave.forEach(row => {
        set(row.product.id, row.minStockLevel, row.maxStockLevel);
      });

      await save(itemsToSave.map(row => row.product.id));
    };

    itemsToSave.length > 0 && saveInitialStocks().catch(console.error);
  }, []);
};
